import { lazy, Suspense, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const PwaInstallPrompt = lazy(() => import('./PwaInstallPrompt'));
const LiveChatWidget = lazy(() => import('./LiveChatWidget'));

function isAdminPath(pathname: string): boolean {
  return pathname === '/admin' || pathname.startsWith('/admin/');
}

/**
 * Loads non-critical floating widgets after idle so they stay off the LCP path.
 * Merchant PWA install is hidden on /admin/* — admin uses AdminPwaInstallPrompt instead.
 */
export default function DeferredWidgets() {
  const { pathname } = useLocation();
  const [ready, setReady] = useState(false);
  const onAdmin = isAdminPath(pathname);

  useEffect(() => {
    let cancelled = false;
    const show = () => {
      if (!cancelled) setReady(true);
    };

    if ('requestIdleCallback' in window) {
      const id = requestIdleCallback(show, { timeout: 5000 });
      return () => {
        cancelled = true;
        cancelIdleCallback(id);
      };
    }

    const timer = setTimeout(show, 3000);
    return () => {
      cancelled = true;
      clearTimeout(timer);
    };
  }, []);

  if (!ready) return null;

  return (
    <Suspense fallback={null}>
      {!onAdmin && <PwaInstallPrompt />}
      {!onAdmin && <LiveChatWidget />}
    </Suspense>
  );
}
